import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { AiLink } from '@vy/ui-design-system';
import { useNavigate } from 'react-router-dom';
import type { VisualizationLink } from './types';

export function CopilotVisualizationLink({ label, href }: VisualizationLink) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(href);
  };

  return (
    <Box sx={{ mt: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', mb: '4px' }}>
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: 12,
            lineHeight: '16px',
            color: '#152232',
          }}
        >
          Links
        </Typography>
        <AiLink width={16} height={16} />
      </Box>
      <Box
        onClick={handleClick}
        data-vy="ai-copilot-deep-link"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          fontFamily: 'Inter, sans-serif',
          fontSize: 12,
          fontWeight: 400,
          lineHeight: '16px',
          color: '#6282FF',
          cursor: 'pointer',
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        {label}
      </Box>
    </Box>
  );
}
